
// import NotFound from '@/views/404.vue'
// import Login from '@/views/Login.vue'
// import Home from '@/views/Home.vue'
// import Data from '@/views/Data.vue'

// import Create from '@/views/Create.vue'
// // 各级导航分组件
// import Peoplemanage from '@/views/nav/Cloud_Dev_Manger.vue'
// import GoodQbank from '@/views/nav/Local_Dev_Manger.vue'
// import Update from '@/views/nav/Update.vue'
// import DataManger from '@/views/nav/DataManger.vue'
// import phonePeople from '@/views/nav/phonePeople.vue'
// import Schoollist from '@/views/nav/Schoollist.vue'

// import Vue from 'vue'
// import Router from 'vue-router'   article
import Router from 'vue-router'

const NotFound = () => import('@/views/404.vue')
const Login = () => import('@/views/Login.vue')
const Home = () => import('@/views/Home.vue')
const Data = () => import('@/views/Data.vue')

const Create = () => import('@/views/Create.vue')
// 各级导航分组件
const Peoplemanage = () => import('@/views/nav/Cloud_Dev_Manger.vue')
const GoodQbank = () => import('@/views/nav/Local_Dev_Manger.vue')
const Update = () => import('@/views/nav/Update.vue')
const DataManger = () => import('@/views/nav/DataManger.vue')
const phonePeople = () => import('@/views/nav/phonePeople.vue')
const Schoollist = () => import('@/views/nav/Schoollist.vue')
const dashboard = () => import('@/views/nav/dashboard.vue')
const carManger = () => import('@/views/nav/carManger.vue')
const serviceCentre = () => import('@/views/nav/serviceCentre.vue')
const article = () => import('@/views/nav/article.vue')

// import Vue from 'vue'

// Vue.use(Router);

export default new Router({
  routes: [
    { path: '/login', name: '', component: Login, hidden: true },
    { path: '/404', name: '', component: NotFound, hidden: true },
    { path: '/Create', name: '', component: Create, hidden: true },
    { path: '/Data', name: '', component: Data, hidden: true },

    {
      path: '/',
      component: Home,
      name: '实时统计',
      children: [
        { path: '/dashboard', name: 'dashboard', component: dashboard }
      ]
    },

    {
      path: '/',
      component: Home,
      name: '设备监控',
      children: [
        { path: '/Cloud_Dev_Manger', name: 'Cloud_Dev_Manger', component: Peoplemanage }
      ]
    },

    {
      path: '/',
      component: Home,
      name: '更新说明',
      children: [
        { path: '/carManger', name: 'carManger', component: carManger }
      ]
    },

    {
      path: '/',
      component: Home,
      name: '更新说明',
      children: [
        { path: '/Update', name: 'Update', component: Update }
      ]
    },

    {
      path: '/',
      component: Home,
      name: '学校列表',
      children: [
        { path: '/Schoollist', name: 'Schoollist', component: Schoollist }
      ]
    },

    {
      path: '/',
      component: Home,
      name: '机器管理',
      children: [
        { path: '/Local_Dev_Manger', name: 'Local_Dev_Manger', component: GoodQbank }
      ]
    },

    {
      path: '/',
      component: Home,
      name: '数据监控',
      children: [
        { path: '/DataManger', name: 'DataManger', component: DataManger }
      ]
    },

    {
      path: '/',
      component: Home,
      name: '工单管理',
      children: [
        { path: '/serviceCentre', name: 'serviceCentre', component: serviceCentre }
      ]
    },

    {
      path: '/',
      component: Home,
      name: '文章管理',
      children: [
        { path: '/article', name: 'article', component: article }
      ]
    },

    {
      path: '/',
      component: Home,
      name: '话机管理',
      children: [
        { path: '/phonePeople', name: 'phonePeople', component: phonePeople }
      ]
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js